<ng-template #template>
  <div class="sd-translation-line-skeleton"></div>
</ng-template>